import { render, staticRenderFns } from "./is-quiz.vue?vue&type=template&id=8f4b39da&scoped=true"
import script from "./is-quiz.vue?vue&type=script&lang=js"
export * from "./is-quiz.vue?vue&type=script&lang=js"
import style0 from "./is-quiz.vue?vue&type=style&index=0&id=8f4b39da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4b39da",
  null
  
)

export default component.exports